import React, {useEffect, useState} from 'react';
import {Button} from '../../components/Button';
import {DirectoryBar} from '../../components/DirectoryBar';
import {H3} from '../../components/H3';
import {H6} from '../../components/H6';
import {AccountSection} from '../../components/MyPage/AccountSection';
import {InfoItem} from '../../components/MyPage/InfoItem';
import {InfoSection} from '../../components/MyPage/InfoSection';
import {MProductCard} from '../../components/MyPage/MProductCard';
import {ShippingInfoSection} from '../../components/MyPage/ShippingInfoSection';
import {PaymentInfoItem} from '../../components/PaymentInfoItem';
import {PopUp} from '../../components/PopUp';
import {Section} from '../../components/Section';
import {Table} from '../../components/Table';
import {useHistory, useParams} from "react-router-dom";
import useOrderDetail from "../../hooks/useOrderDetail";
import OrderNumberSection from "../../components/OrderNumberSection";
import moment from "moment";
import {bankName, swapPayMethod, swapProductShippingStatus} from "../../utils/texts";
import {cancelOrderRequest, changeRequestShippingAddress, orderChangeAvailable} from "../../apis/orders";
import {nToast} from "../../plugins/reactToast";
import {
    OrderCancelRequest,
    OrderChangeAddressDto,
    OrderPaidProduct,
    TOrderDetail
} from "../../types/types";
import { useUserState } from '../../context/UserContext';
import {getRefundTypeName} from "../../utils/getRefundTypeName";
import TrackingNumber from "../../components/MyPage/TrackingNumber";
import {Checkbox} from "../../components/Checkbox";

export const RefundDetail = () => {
    const {orderNumber} = useParams<{ orderNumber: string }>();
    const [popUp, setPopUp] = useState(false);
    const {order, getOrderDetail} = useOrderDetail(orderNumber);
    const [refundAccount, setRefundAccount] = useState<{ refundAccountBank?: string, refundAccountNumber?: string }>()
    const {isLoggedIn} = useUserState()
    const [selected, setSelected] = useState<OrderPaidProduct[]>([]);

    const itemIndex = (item: OrderPaidProduct) => {
        return selected.findIndex(i => i === item)
    }

    const onChecked = (product: OrderPaidProduct) => {
        itemIndex(product) > -1 ? setSelected([...selected.filter(i => i !== product)]) : setSelected([...selected, product])
    }

    useEffect(() => {
        if (order) {
            setSelected(order.orderRequestExtra?.products || [])
        }
    }, [order]);

    if (!order) return null

    const onCancel = () => {
        let data: OrderCancelRequest = {}
        data.customerName = order.customerName
        data.customerPhone = order.customerPhone
        data.cancelOrderProducts = selected.map(item => ({
            cancelOrderProductId: item.orderProductId
        }))
        // if (order.orderRequestExtra?.payMethod !== 'CARD' && refundAccount?.refundAccountNumber && refundAccount?.refundAccountBank) {
        //     // @ts-ignore
        //     data.bankCode = refundAccount?.refundAccountBank
        //     data.bankNumber = refundAccount?.refundAccountNumber
        //     data.bankOwner = order.customerName
        // } else {
        //     nToast('환불받으실 계좌 정보를 입력해 주세요')
        //     return;
        // }
        orderChangeAvailable(order.orderRequestExtra?.requestOrderNumber || order.orderNumber).then(() => {
            cancelOrderRequest(order.orderRequestExtra?.requestOrderNumber!, data)
                .then(_ => {
                    nToast('신청 취소가 완료되었습니다');
                    getOrderDetail();
                })
        }).catch(() => {
            nToast('이미 배송 및 반품 처리가 시작된 주문은 변경할 수 없습니다.');
        });
    }

    const changeAddress = (data: OrderChangeAddressDto) => {
        changeRequestShippingAddress(orderNumber, data)
            .then(res => {
                getOrderDetail();
                nToast('배송정보 수정이 완료되었습니다.');
            })
    }

    return (
        <>
            <DirectoryBar text={'교환 · 반품 내역'} backArrow className="md:hidden"/>
            <div className="py-4">
                {order.orderRequestExtra?.type === 'EXCHANGE' ? (
                    <>
                        <PopUp
                            title="정말 교환신청을 취소 하시겠습니까?"
                            buttonText="취소하기"
                            open={popUp}
                            onClose={() => setPopUp(false)}
                            onClick={onCancel}
                        />

                        <div className={isLoggedIn ? "space-y-14 pb-20" : "md:mx-auto md:my-30 max-w-screen-xl space-y-14"}>
                            <Section className="space-y-4 text-13">
                                <H6 className="border-b pb-2">교환 신청</H6>
                                <OrderNumberSection orderNumber={order.orderRequestExtra.requestOrderNumber}
                                                    orderedAt={order.orderRequestExtra.requestedAt!}/>

                                <RequestOptionButtons order={order} selectedProducts={selected} orderNumber={orderNumber}
                                                      allSelectButtonPressed={() => setSelected(order.orderRequestExtra?.products!)}
                                />

                                {/* desktop */}
                                <Table className="hidden md:table">
                                    <Table.Head>
                                        <Table.Row>
                                            <Table.Th>
                                                <Checkbox className="bg-white border border-gray-300"
                                                          checked={order.orderRequestExtra?.products === selected}
                                                          onChange={() => order.orderRequestExtra?.products === selected ? setSelected([]) : setSelected(order.orderRequestExtra?.products!)}
                                                />
                                            </Table.Th>
                                            <Table.Th>상품</Table.Th>
                                            <Table.Th>교환 사유</Table.Th>
                                            {order.orderRequestExtra?.type === 'EXCHANGE' && (<Table.Th>배송 상태</Table.Th>)}
                                        </Table.Row>
                                    </Table.Head>
                                    <Table.Body>
                                        {order.orderRequestExtra?.products.map((product, index) => (
                                            <Table.Row key={index}>
                                                <Table.Td>
                                                    <Checkbox className="bg-white border border-gray-300"
                                                              checked={itemIndex(product) > -1}
                                                              onChange={() => onChecked(product)}
                                                    />
                                                </Table.Td>
                                                <Table.Td>
                                                    <MProductCard
                                                        thumbnail={product.thumbnailUrl}
                                                        name={product.productName}
                                                        color={product.color}
                                                        price={product.unitPrice.toLocaleString()}
                                                        quantity={product.count}
                                                    />
                                                </Table.Td>

                                                <Table.Td>
                                                    {product.latestRequestReason || (product.latestRequestSizeName ? <p className="text-10 font-bold">사이즈 변경 : {product.latestRequestSizeName}</p> : '')}
                                                </Table.Td>

                                                <Table.Td>
                                                    <p className="font-bold text-gray-900">{swapProductShippingStatus(product.productStatus, product.latestRequest, product.latestRequestStatus!)}</p>
                                                    {product.productStatus === 'IN_RETURN' ? (
                                                        product.latestRequestShippingCompany && (
                                                            <p className="font-normal text-13">
                                                                {product.latestRequestShippingCompany} <br/>
                                                                <TrackingNumber
                                                                    shippingTrackingNumber={product.latestRequestShippingTrackingNumber!}/>
                                                            </p>
                                                        )
                                                    ) : (
                                                        <p className="font-normal text-13">
                                                            {product.shippingCompany} <br/>
                                                            <TrackingNumber
                                                                shippingTrackingNumber={product.shippingTrackingNumber!}/>
                                                        </p>
                                                    )}
                                                </Table.Td>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>

                                {/* mobile */}
                                <Section className="md:hidden">
                                    {order.orderRequestExtra?.products.map((product, index) => (
                                        <div className="flex justify-between items-center border-b pb-4 mb-4"
                                             key={index}>
                                            <Checkbox className="bg-white border border-gray-300"
                                                      checked={itemIndex(product) > -1}
                                                      onChange={() => onChecked(product)}
                                            />
                                            <div className="">
                                                <MProductCard
                                                    thumbnail={product.thumbnailUrl}
                                                    name={product.productName}
                                                    color={product.color}
                                                    price={product.unitPrice.toLocaleString()}
                                                    quantity={product.count}
                                                    content={
                                                        <div>
                                                            <p className="text-brand-3">
                                                                사이즈: {order.products[0].sizeName}
                                                            </p>
                                                            <p className="text-brand-3">
                                                                적립금 적립: {product.earnedMileage.toLocaleString()}
                                                            </p>
                                                        </div>
                                                    }
                                                />
                                            </div>
                                            {product.latestRequestReason || (product.latestRequestSizeName ? <p className="text-10 font-bold">사이즈 변경 : {product.latestRequestSizeName}</p> : '')}
                                        </div>
                                    ))}
                                </Section>

                                <p className="md:border-t md:border-gray-200 pt-4 flex flex-row-reverse text-12 text-gray-500">
                                    *교환 진행시, 교환 신청한 사이즈가 품절될 시 환불처리가
                                    진행됩니다.
                                </p>
                            </Section>

                            <InfoSection name={order.customerName!} phone={order.customerPhone!}/>

                            <ShippingInfoSection order={order}
                                                 hideActions={order.orderRequestExtra.status !== 'PENDING'}
                                                 isExchange={true}
                                                 onChangeAddress={changeAddress}/>

                            {(order.payMethod !== 'CARD' && order.payMethod !== 'KAKAO' && order.payMethod !== 'NAVER') && (
                                <AccountSection order={order}
                                                onChangeAccount={(accountInfo) => setRefundAccount(accountInfo)}
                                />
                            )}

                            <Section className="space-y-4 text-13">
                                <H6 className="border-b pb-2">
                                    교환 비용 결제
                                </H6>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2">
                                    <InfoItem title="총 교환 비용"
                                              content={order.orderRequestExtra?.refundedDelivery ? '취소완료' : (order.orderRequestExtra?.requestDeliveryPrice || 0).toLocaleString() + '원'}
                                          redContent={order.orderRequestExtra?.refundedDelivery}
                                    />
                                    <InfoItem title="교환 비용 결제" content="선결제"/>
                                    <InfoItem title="결제수단" content={swapPayMethod(order.orderRequestExtra?.payMethod)}/>
                                    {order.orderRequestExtra?.payMethod === 'VIRTUAL_ACCOUNT' && (
                                        <>
                                            <InfoItem title="카드사(은행명)"
                                                      content={`${order.orderRequestExtra?.refundAccountNumber} (${bankName(order.orderRequestExtra?.refundAccountBank!)})`}/>
                                            <InfoItem title="카드주(예금주)"
                                                      content={order.orderRequestExtra?.refundAccountName!}/>
                                        </>
                                    )}
                                </div>
                            </Section>

                            <Button
                                disabled={order.orderRequestExtra?.status !== 'PENDING'}
                                onClick={() => setPopUp(true)}
                                text="신청 취소"
                                className="filled-brand-1 w-full"
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <PopUp
                            title="정말 반품신청을 취소 하시겠습니까?"
                            buttonText="취소하기"
                            open={popUp}
                            onClose={() => setPopUp(false)}
                            onClick={onCancel}
                        />
                        <div className={isLoggedIn ? "space-y-14 pb-20" : "md:mx-auto md:my-30 max-w-screen-xl space-y-14"}>
                            <Section className="space-y-4 text-13">
                                <H3 className="border-b border-gray-500 pb-4">반품 신청</H3>

                                <OrderNumberSection orderNumber={order.orderRequestExtra?.requestOrderNumber!}
                                                    orderedAt={order.orderRequestExtra?.requestedAt!}/>

                                <Table className="mt-5">
                                    <Table.Head>
                                        <Table.Row>
                                            <Table.Th>상품</Table.Th>
                                            <Table.Th>반품사유(선택)</Table.Th>
                                        </Table.Row>
                                    </Table.Head>
                                    <Table.Body>
                                        {order.orderRequestExtra?.products.map((product, index) => (
                                            <Table.Row key={index}>
                                                <Table.Td>
                                                    <div className="flex space-x-4 font-normal items-center">
                                                        <div className="w-20 h-16 relative">
                                                            <img src={product.thumbnailUrl}
                                                                 alt=""
                                                                 className="w-full h-full object-cover absolute"
                                                            />
                                                        </div>
                                                        <div className="space-y-2">
                                                            <p className="text-14 uppercase whitespace-normal font-semibold">
                                                                {product.productName}
                                                            </p>

                                                            <p className="text-13">{product.unitPrice.toLocaleString()}원/수량 {product.count}개</p>
                                                        </div>
                                                    </div>
                                                </Table.Td>

                                                <Table.Td>
                                                    <p>{product.latestRequestReason || '-'}</p>
                                                    {/*<TextField*/}
                                                    {/*    className="border-gray-100"*/}
                                                    {/*    placeholder={`사유를 입력해주세요.`}*/}
                                                    {/*/>*/}
                                                </Table.Td>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                                <p className="border-t border-gray-200 pt-4 flex flex-row-reverse text-gray-500 text-13">
                                    *교환 진행시, 교환 신청한 사이즈가 품절될 시 환불처리가
                                    진행됩니다.
                                </p>
                            </Section>

                            <InfoSection name={order.customerName!} phone={order.customerPhone!}/>

                            <ShippingInfoSection order={order}
                                                 hideActions={order.orderRequestExtra?.status !== 'PENDING'}
                                                 isExchange={true}
                                                 onChangeAddress={changeAddress}/>

                            <Section className="space-y-4 text-13">
                                <H6 className="border-b pb-4">
                                    반품 비용 결제
                                </H6>

                                <div className="grid grid-cols-2">
                                    <InfoItem title="총 반품 비용"
                                              content={order.orderRequestExtra?.refundedDelivery ? '취소완료' : (order.orderRequestExtra?.requestDeliveryPrice || 0).toLocaleString() + '원'}
                                              redContent={order.orderRequestExtra?.refundedDelivery}
                                    />
                                    <InfoItem title="반품 비용 결제" content="선결제"/>
                                </div>
                            </Section>

                            <Section>
                                <H6 className="">결제 수단</H6>
                                {swapPayMethod(order.orderRequestExtra?.payMethod!)}
                                {/*<Select*/}
                                {/*    className="w-1/6"*/}
                                {/*    onChange={(e) => console.log(e.target.value)}*/}
                                {/*>*/}
                                {/*    <option value="1">신용카드</option>*/}
                                {/*    <option value="2">option 2</option>*/}
                                {/*    <option value="3">option 3</option>*/}
                                {/*</Select>*/}
                            </Section>

                            {(order.payMethod !== 'CARD' && order.payMethod !== 'KAKAO' && order.payMethod !== 'NAVER') && (
                                <AccountSection order={order}
                                                onChangeAccount={(accountInfo) => setRefundAccount(accountInfo)}
                                />
                            )}

                            {/* Mobile */}
                            <div className={'md:hidden'}>
                                <div className="space-y-2 border-b border-gray-200 pb-4 mb-4">
                                    <div className="flex justify-between">
                                        <p className="">총 주문 금액</p>
                                        <p className="font-bold">{order.totalPrice.toLocaleString()}원</p>
                                    </div>
                                    <PaymentInfoItem title="상품금액" content={`${order.productPrice.toLocaleString()}원`}/>
                                    <PaymentInfoItem title="배송비" content={`${order.deliveryPrice.toLocaleString()}원`}/>
                                </div>

                                <div className="space-y-2 border-b border-gray-200 pb-4 mb-4">
                                    <div className="flex justify-between">
                                        <p className="">총 할인 금액</p>
                                        <p className="font-bold">-{order.discountPrice.toLocaleString()}원</p>
                                    </div>
                                    <PaymentInfoItem title="쿠폰" content={`-${order.couponDiscount.toLocaleString()}원`}/>
                                    <PaymentInfoItem title="적립금" content={`-${order.usedMileage.toLocaleString()}원`}/>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <p className="">총 환불 금액</p>
                                        <p className="font-semibold text-red-500">{(order.orderRequestExtra?.totalPaidPrice || 0).toLocaleString()}원</p>
                                    </div>
                                    <PaymentInfoItem title="반환 적립금"
                                                     content={`${(order.orderRequestExtra?.canceledMileage || 0).toLocaleString()}원`}/>
                                    <PaymentInfoItem title="환불일" content={order.orderRequestExtra?.refundedAt ? moment(order.orderRequestExtra?.refundedAt).format('YYYY.MM.DD') : '-'}/>
                                    <PaymentInfoItem title="환불처리" content={getRefundTypeName(order.orderRequestExtra?.payMethod!)}/>
                                </div>
                            </div>

                            {/* Desktop */}
                            <Section className="hidden md:block">
                                <H6 className="border-b border-gray-200 pb-4">환불 정보</H6>

                                <div className="grid grid-cols-3 divide-x">
                                    <Section className="divide-y pt-4">
                                        <div className="flex justify-between px-4 pb-4">
                                            <p className="">총 주문 금액</p>
                                            <p className="text-17 font-semibold">{order.totalPrice.toLocaleString()}원</p>
                                        </div>

                                        <div className="space-y-2 p-4">
                                            <PaymentInfoItem title="상품금액"
                                                             content={`${order.productPrice.toLocaleString()}원`}/>
                                            <PaymentInfoItem title="배송비"
                                                             content={`${order.deliveryPrice.toLocaleString()}원`}/>
                                        </div>
                                    </Section>

                                    <Section className="divide-y pt-4">
                                        <div className="flex justify-between px-4 pb-4">
                                            <p className="">총 할인 금액</p>
                                            <p className="text-17 font-semibold">-{order.discountPrice.toLocaleString()}원</p>
                                        </div>

                                        <div className="space-y-2 p-4">
                                            <PaymentInfoItem title="쿠폰할인"
                                                             content={`-${order.couponDiscount.toLocaleString()}원`}/>
                                            <PaymentInfoItem title="적립금"
                                                             content={`-${order.usedMileage.toLocaleString()}원`}/>
                                        </div>
                                    </Section>

                                    <Section className="divide-y pt-4">
                                        <div className="flex justify-between px-4 pb-4">
                                            <p className="">총 환불 금액</p>
                                            <p className="text-17 font-semibold text-red-500">
                                                {(order.orderRequestExtra?.totalPaidPrice || 0).toLocaleString()}원
                                            </p>
                                        </div>

                                        <div className="space-y-2 p-4">
                                            <PaymentInfoItem title="반환 적립금"
                                                             content={`${(order.orderRequestExtra?.canceledMileage || 0).toLocaleString()}원`}/>
                                            <PaymentInfoItem title="환불일"
                                                             content={order.orderRequestExtra?.refundedAt ? moment(order.orderRequestExtra?.refundedAt).format('YYYY.MM.DD') : '-'}/>
                                            <PaymentInfoItem title="환불처리"
                                                             content={getRefundTypeName(order.orderRequestExtra?.payMethod!)}/>
                                        </div>
                                    </Section>
                                </div>
                            </Section>

                            <div className="flex flex-row-reverse font-normal">
                                {/* 대기상태일때만 */}
                                <Button
                                    disabled={order.orderRequestExtra?.status !== 'PENDING'}
                                    onClick={() => setPopUp(true)}
                                    text="신청 취소"
                                    className="filled-brand-1 w-full"
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};


type OptionButtonsProps = {
    orderNumber?: string;
    selectedProducts?: OrderPaidProduct[];
    order?: TOrderDetail;
    allSelectButtonPressed?: () => void;
}

const RequestOptionButtons = (props: OptionButtonsProps) => {
    const {
        orderNumber,
        selectedProducts,
        order,
        allSelectButtonPressed,
    } = props;
    const {isLoggedIn} = useUserState();
    const history = useHistory();

    const movingData = isLoggedIn ? {products: selectedProducts} : {nOrder: order, products: selectedProducts};

    const targetBasePath = isLoggedIn ? '/mypage/orders' : '/non-member';

    const canExchange = selectedProducts?.filter(product => product.productStatus === ('DELIVERED' || 'RETURNED') || product.latestRequestStatus === 'DELIVERED').length === selectedProducts?.length && selectedProducts?.length !== 0;

    return (
        <div className={'flex justify-end space-x-5'}>
            {/*<button*/}
            {/*    className={`md:hidden inline-block text-13 bg-gray-100 px-3 py-2`} */}
            {/*    onClick={allSelectButtonPressed}*/}
            {/*    disabled={true}*/}
            {/*>*/}
            {/*    전체 선택*/}
            {/*</button>*/}
            <button
                className={`inline-block text-13 bg-gray-100 px-3 py-2 ${(!canExchange) ? 'text-gray-300' : ''}`}
                disabled={!canExchange}
                onClick={() => selectedProducts?.length === 0 ? nToast('상품을 선택해 주세요') :
                    history.push(`${targetBasePath}/${order?.orderNumber}/exchange`, movingData)
                }
            >
                교환 신청
            </button>
            <button
                className={`inline-block text-13 bg-gray-100 px-3 py-2 ${(!canExchange) ? 'text-gray-300' : ''}`}
                disabled={!canExchange}
                onClick={() => selectedProducts?.length === 0 ? nToast('상품을 선택해 주세요') :
                    history.push(`${targetBasePath}/${order?.orderNumber}/refund`, movingData)
                }
            >
                반품 신청
            </button>
        </div>
    )
}
